import React from 'react';

const CiscoLogo = ({ className = 'h-6 w-auto', color = '#00bceb' }) => {
  // Stylised Cisco 'bars' + text (mock, not the real trademark file)
  const bars = [10, 22, 34, 8, 22, 34, 22, 10];
  return (
    <div className={`inline-flex items-end ${className}`} aria-label="Cisco">
      <svg viewBox="0 0 120 44" className="h-full w-auto" fill="none">
        <g fill={color}>
          {bars.map((h, i) => (
            <rect key={i} x={4 + i * 6} y={22 - h} width="3" height={h} rx="1.5" />
          ))}
        </g>
        <text x="4" y="40" fontFamily="Inter, Arial" fontWeight="700" fontSize="14" letterSpacing="2" fill={color}>
          CISCO
        </text>
      </svg>
    </div>
  );
};

export default CiscoLogo;
